import { useEffect, useRef, useState, ReactNode } from 'react';
import { LinkButton } from '../../../link/LinkButton';

interface ExpandableContentProps {
  children: ReactNode;
  maxHeight?: number;
  showMoreButtonText?: string;
  showLessButtonText?: string;
}

export function ExpandableContent({
  children,
  maxHeight = 35,
  showMoreButtonText = 'Show more',
  showLessButtonText = 'Show less'
}: ExpandableContentProps) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (contentRef.current) {
      setShowButton(contentRef.current.scrollHeight > maxHeight);
    }
  }, [children, maxHeight]);

  return (
    <>
      <div
        ref={contentRef}
        className='overflow-hidden'
        style={{ maxHeight: isExpanded ? 'none' : `${maxHeight}px` }}
      >
        {children}
      </div>

      {showButton && (
        <LinkButton
          dataId='show-more-button'
          className='mt-2'
          onClick={() => setIsExpanded(!isExpanded)}
        >
          {isExpanded ? showLessButtonText : showMoreButtonText}
        </LinkButton>
      )}
    </>
  );
}
